import { branch, compose } from 'recompose';

import ReleaseVersionMetadata from './Release/ReleaseVersionMetadata';
import GroupReleaseMetadata from './Release/GroupReleaseMetadata';
import ArtistMetadata from './Artist/ArtistMetadata.js';
import LabelMetadata from './Label/LabelMetadata';
import ProjectMetadata from './Project/ProjectMetadata';
import TrackVersionMetadata from './Track/TrackVersionMetadata';
import GroupTrackMetadata from './Track/GroupTrackMetadata';
import { apiTypeToEntityType } from 'helpers/mapEntityTypes';

/**
 * This component picks the right meta data component for
 * entities based on the `entityType` prop.
 */
function Metadata(props) {
  switch (apiTypeToEntityType(props.entityType)) {
    case 'release':
      return <ReleaseVersionMetadata {...props} />;
    case 'artist':
      return <ArtistMetadata {...props} />;
    case 'label':
      return <LabelMetadata {...props} />;
    case 'project':
      return <ProjectMetadata {...props} />;
    case 'track':
      return <TrackVersionMetadata {...props} />;
    default:
      return null;
  }
}

/**
 * This component picks the right meta data component for
 * grouped entities (parents of versions) based on the `entityType` prop.
 */
function GroupMetadata(props) {
  switch (apiTypeToEntityType(props.entityType)) {
    case 'release':
      return <GroupReleaseMetadata {...props} />;
    case 'track':
      return <GroupTrackMetadata {...props} />;
    case 'artist':
      return <Metadata {...props} />;
    default:
      return null;
  }
}

const showIfGroup = (isGroup) => branch(isGroup, () => GroupMetadata);

export default compose(showIfGroup(({ isGroup }) => isGroup))(Metadata);
